import React, { useState } from "react";
import { Plus, Minus } from "@phosphor-icons/react";
import { FAQS, faqJsonLd } from "../../lib/faqs";

/**
 * Visible FAQ accordion with FAQPage JSON-LD schema for Google rich results.
 * Drop on any page where homeowner questions are relevant.
 */
export default function FAQSection({ limit = FAQS.length, title = "Frequently asked", subtitle = "Common questions from homeowners — answered straight." }) {
  const [open, setOpen] = useState(0); // first item open by default
  const items = FAQS.slice(0, limit);

  return (
    <section className="section-pad bg-atc-paper" data-testid="faq-section">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd()) }} />
      <div className="container-max grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="overline mb-4">FAQ</div>
          <h2 className="h-section">{title.split(" ").map((w, i) => i === 1 ? <span key={i}><br/>{w}</span> : w + " ")}</h2>
          <p className="mt-5 text-atc-muted">{subtitle}</p>
        </div>
        <div className="md:col-span-8">
          <dl className="divide-y-2 divide-atc-black border-2 border-atc-black bg-white">
            {items.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={i} data-testid={`faq-item-${i}`}>
                  <dt>
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="w-full text-left px-6 py-5 flex items-center justify-between gap-4 font-heading uppercase tracking-wide text-atc-black hover:bg-atc-paper transition-colors"
                      aria-expanded={isOpen}
                      data-testid={`faq-toggle-${i}`}
                    >
                      <span>{f.q}</span>
                      {isOpen ? <Minus size={20} weight="bold" className="shrink-0 text-atc-red" /> : <Plus size={20} weight="bold" className="shrink-0 text-atc-red" />}
                    </button>
                  </dt>
                  {isOpen && (
                    <dd className="px-6 pb-6 -mt-1 text-atc-charcoal leading-relaxed">{f.a}</dd>
                  )}
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
}
